<div class="notification-panel" [ngClass]="{ 'show-notification-panel': showPanel }">
    <div class="notification-logo"></div>
    <div class="notification-panel-content">
        <div class="notification-title">{{ notification?.title }}</div>
        <div class="notification-body">{{ notification?.body }}</div>
    </div>
    <div class="notification-close" (click)="dismissNotification()">
        <span class="material-icons">close</span>
    </div>
</div>